import { devPWAConfig } from './firebase.config';
export const environment = {
  production: false,
  demo: false,
  dev: true,
  firebaseConfig: devPWAConfig,
};
